import React from 'react';
import { Button, Space, Divider } from 'antd';
import { useTranslation } from 'react-i18next';
import { ImportPathTemplateTasksButton } from './ImportPathTemplateTasksButton';
import { GroupedTaskDataFormValues } from './FormGroupedTaskData';

interface Props {
  onAddTask: () => void;
  onGroupTasks: () => void;
  onImport: (data: GroupedTaskDataFormValues) => void;
  groupEnable: boolean;
  community: string | undefined;
}

export const HeaderActions: React.FC<Props> = (props) => {
  const { onAddTask, onGroupTasks, onImport, groupEnable, community } = props;
  const { t } = useTranslation(undefined, {
    keyPrefix: 'pathTemplates.details.groupTasks',
  });
  return (
    <>
      <Divider />
      <Space className="mb-3">
        <Space>
          <Button onClick={onAddTask}>{t('add')}</Button>
          <ImportPathTemplateTasksButton
            onImport={onImport}
            communityId={community}
          />
          <Button onClick={onGroupTasks} disabled={!groupEnable}>
            {t('group')}
          </Button>
        </Space>
      </Space>
    </>
  );
};
